export default __webpack_public_path__ + "static/media/iot.9a1b82b0.png";